/**
 * How a customer picker names a website: the website, and the account behind
 * it when that adds anything. "MAD" alone is a name nobody recognises; "MAD ·
 * Die Kuh vom Eis GmbH" is the customer. The account is the owner's company,
 * or their name when the account has none; nothing is appended when it would
 * only repeat the website's name.
 */
import _ from 'lodash';

export const accountLabel = (cms) => {
    const owner = _.get(cms, 'owner.user') || {};
    const account = String(owner.company || `${owner.first_name || ''} ${owner.last_name || ''}`).trim();

    return account && account.toLowerCase() !== String(cms.name || '').trim().toLowerCase() ? account : '';
};

export const customerLabel = (cms) => {
    const account = accountLabel(cms);

    return account ? `${cms.name} · ${account}` : cms.name;
};
